export default "__VITE_ASSET__76MlfF1l__"